import {
  Button,
  message,

  Popconfirm,
  Popover,
  Select,
  Space,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { SearchColumn } from "../../Components/TableSettings/TableSettings";
import {
  InboxOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  FieldTimeOutlined,
  PauseCircleOutlined,
  CloseOutlined,
  CheckOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useNavigate } from "react-router-dom";
import * as actions from "../../store/actions/action";
import { connect } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "./Requests.module.css";
import api from "../../api/api";
import DataTable from "../../Components/DataTable/DataTable";
import StatusSetter from "../../util/StatusSetter";
import LastPlacementTestSetter from "../../util/LastPlacementTestSetter";
import TableExportDropdown from "../../Components/TableExportDropdown/TableExportDropdown";
import { PageHeader } from "@ant-design/pro-components";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
dayjs.extend(relativeTime);

const Requests = ({
  ErrorSetter,
  ClearError,
  LoadingSetter,
  ClearLoading,
  token,
  loading,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const AuthHeader = { Authorization: "Token " + token };
  const fetchData = () => {
    LoadingSetter();
    const statusParamsArray = ["NO", "TD", "TE"].map((el) => {
      return "status=" + el;
    });
    const params = new URLSearchParams(statusParamsArray.join("&"));
    api
      .get("/students", { headers: { ...AuthHeader }, params: params })
      .then((res) => {
        setData(res.data);
        ClearLoading();
      })
      .catch((err) => {
        ErrorSetter(
          "دریافت اطلاعات با مشکل مواجه شد، لطفا صفحه را ریفرش کنید."
        );
        ClearLoading();
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  const [dateInputError, setDateInputError] = useState(null);
  const [scoreInputError, setScoreInputError] = useState(null);
  const Search = new SearchColumn(
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );
  //Update Data
  const UpdateStatus = (record, status) => {
    const newDataSource = [...data];
    newDataSource[newDataSource.indexOf(record)].status = status;
    setData(newDataSource);
    ClearError();
  };

  const UpdateTestDate = (record, value) => {
    const newDataSource = [...data];
    const element = newDataSource[newDataSource.indexOf(record)];
    if (element.placement_tests.length === 0) {
      newDataSource[newDataSource.indexOf(record)].placement_tests = [
        { jactive_due_date: value },
      ];
    } else {
      newDataSource[newDataSource.indexOf(record)].placement_tests[
        element.placement_tests.length - 1
      ].jactive_due_date = value;
    }
    setData(newDataSource);
    ClearError();
    setDateInputError(null);
  };
  const UpdateOrganicField = (value, record) => {
    const newDataSource = [...data];
    newDataSource[newDataSource.indexOf(record)].is_organic = value;
    setData(newDataSource);
    ClearError();
    setDateInputError(null);
  };
  //Buttons OnClick Functions
  const SetStatus = (record, status, successMessage, onSuccessFunction) => {
    api
      .patch(
        "/student/" + record.id,
        { status, is_organic: record.is_organic },
        { headers: { ...AuthHeader } }
      )
      .then(() => {
        UpdateStatus(record, status);
        message.success(successMessage);
        ClearLoading();
        if (onSuccessFunction) {
          onSuccessFunction();
        }
      })
      .catch(() => {
        ClearLoading();
        ErrorSetter("مشکلی در تغییر وضعیت پیش آمده.");
      });
  };
  const SendTestDate = (id, successMessage, record) => {
    api
      .post("send-pt-date-sms", { id }, { headers: { ...AuthHeader } })
      .then(() => {
        SetStatus(record, "TD", successMessage);
      })
      .catch(() => {
        ClearLoading();
        ErrorSetter("ارسال تاریخ تعیین سطح به کاربر با مشکل مواجه شد.");
      });
  };
  const SetTestDate = (record) => {
    const last_placement_test_value = LastPlacementTestSetter(record);
    const DataSource = [...data];
    const element = DataSource[DataSource.indexOf(record)];
    if (element.placement_tests.length !== 0) {
      const last_placement_tests =
        element.placement_tests[element.placement_tests.length - 1];
      const jactive_due_date = last_placement_tests.jactive_due_date;
      const active_due_date = new Date(
        dayjs(jactive_due_date, { jalali: true })
      ).toISOString();
      LoadingSetter();
      let stopProccess = false;
      data.forEach((rec) => {
        const test_value = LastPlacementTestSetter(rec);
        if (data.indexOf(rec) !== data.indexOf(record) && test_value) {
          if (test_value.jactive_due_date === jactive_due_date) {
            setDateInputError(record);
            message.error("این تاریخ و ساعت تعیین سطح قبلا ثبت شده است.");
            stopProccess = true;
          }
        }
      });
      if (stopProccess) {
        ClearLoading();
        return;
      } else {
        if (last_placement_test_value.due_dates) {
          api
            .patch(
              "/placement-test/" + last_placement_test_value.id,
              { active_due_date },
              { headers: { ...AuthHeader } }
            )
            .then((res) => {
              SendTestDate(
                last_placement_test_value.id,
                "تاریخ تعیین سطح با موفقیت بروزرسانی شد.",
                record
              );
              updatePlacementDate(res.data);
            })
            .catch(() => {
              ErrorSetter("مشکلی در بروزرسانی تاریخ پیش آمده.");
              ClearLoading();
            });
        } else {
          api
            .post(
              "/add-placement-test",
              { student: record.id, active_due_date },
              { headers: { ...AuthHeader } }
            )
            .then((res) => {
              updatePlacementDate(res.data);
              SendTestDate(
                res.data.id,
                "تاریخ تعیین سطح با موفقیت ثبت شد.",
                record
              );
            })
            .catch(() => {
              ClearLoading();
              ErrorSetter("ثبت تاریخ تعیین سطح با مشکل مواجه شد!");
            });
        }
        const updatePlacementDate = (date) => {
          DataSource[DataSource.indexOf(record)].placement_tests[
            element.placement_tests.length - 1
          ] = date;
          setData(DataSource);
        };
      }
    } else {
      message.error("تاریخ تعیین سطح وارد نشده است.");
      setDateInputError(record);
    }
  };
  const SendTestResult = (record) => {
    const last_placement_test_value = LastPlacementTestSetter(record);

    if (
      last_placement_test_value.level !== null &&
      last_placement_test_value.curriculum.length > 0 &&
      last_placement_test_value.description
    ) {
      LoadingSetter();
      api
        .post(
          "/send-pt-result-sms",
          { id: last_placement_test_value.id },
          { headers: { ...AuthHeader } }
        )
        .then((res) => {
          SetStatus(record, "TE", "ارسال نتیجه تعیین سطح با موفقیت ثبت شد.");
        })
        .catch(() => {
          ErrorSetter("مشکلی در ارسال نتیجه تعیین سطح پیش آمده.");
          ClearLoading();
        });
    } else {
      console.log(last_placement_test_value);

      message.error("اطلاعات تعیین سطح وارد نشده است.");
      setScoreInputError(record);
    }
  };
  const SetTestDateAgain = (record) => {
    UpdateStatus(record, "NO");
  };
  const SetRegister = (record) => {
    LoadingSetter();
    api
      .post(
        "/send-thanks-sms",
        { id: record.id },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        message.success("اس ام اس ثبت نام کاربر ارسال شد.");
        SetStatus(record, "RE", "ثبت نام با موفقیت انجام شد.", () => {
          RemoveData(record);
        });
      })
      .catch(() => {
        ClearLoading();
        message.error("مشکلی در ارسال اس ام اس به کاربر پیش آمده.");
      });
  };
  const AddToTrackingList = (record) => {
    LoadingSetter();
    SetStatus(record, "NC", "درخواست به لیست پیگیری اضافه شد.", () => {
      RemoveData(record);
    });
  };
  const RemoveData = (record) => {
    const newDataSource = [...data];
    const final = newDataSource.filter((dataEl) => {
      return newDataSource.indexOf(dataEl) !== newDataSource.indexOf(record);
    });
    setData(final);
  };
  const DeleteRequest = (record) => {
    LoadingSetter();
    SetStatus(record, "DE", "درخواست با موفقیت حذف شد.", () => {
      RemoveData(record);
    });
  };

  //Table Date

  const StatusFilter = [
    {
      text: "نیازمند تعیین سطح",
      value: "NO",
    },
    {
      text: "تست داده شده",
      value: "TE",
    },
    {
      text: "زمان تعیین سطح داده شده",
      value: "TD",
    },
  ];

  const columns = [
    {
      title: "نام",
      dataIndex: "first_name",
      key: "first_name",
      ...Search.getColumnSearchProps("first_name"),
    },
    {
      title: "نام خانوادگی",
      dataIndex: "last_name",
      key: "last_name",
      ...Search.getColumnSearchProps("last_name"),
    },
    {
      title: "شماره موبایل",
      dataIndex: "phone_number",
      key: "phone_number",
      ...Search.getColumnSearchProps("phone_number"),
    },
    {
      title: "شهر محل سکونت",
      dataIndex: "city_live",
      key: "city_live",
      ...Search.getColumnSearchProps("city_live"),

      // sorter: (a, b) => a.address.length - b.address.length,
      // sortDirections: ['descend', 'ascend'],
    },
    {
      title: "دلیل یادگیری زبان",
      dataIndex: "aim_to_learn",
      key: "aim_to_learn",
      ...Search.getColumnSearchProps("aim_to_learn"),
    },
    {
      title: "شغل",
      dataIndex: "job",
      key: "job",
      width: "7%",
      // ...LongColumn,
      ...Search.getColumnSearchProps("job"),
    },
    {
      title: "تاریخ ثبت درخواست",
      dataIndex: "date_joined",
      key: "date_joined",
      sorter: (a, b) => {
        const aLastDate = dayjs(a.date_joined);
        const bLastDate = dayjs(b.date_joined);

        if (aLastDate.diff(bLastDate) > 0) {
          return 1;
        } else {
          return -1;
        }
      },
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => {
        return (
          <div>
            <Tag>
              <div>{dayjs(record.date_joined).fromNow()}</div>
              <b>
                {record?.jdate_joined ? record?.jdate_joined?.split("T")[0] : ""}
              </b>
            </Tag>
          </div>
        );
      },
    },
    {
      title: "تاریخ تعیین سطح",
      dataIndex: "test_date",
      key: "test_date",
      width: "12%",
      sorter: (a, b) => {
        const aLastDate = a.test_date
          ? a.test_date[a.test_date.length - 1]
          : null;
        const bLastDate = b.test_date
          ? b.test_date[b.test_date.length - 1]
          : null;
        const MakeDateToNum = (date) => {
          return +date.split(" ")[0].split("-").join("");
        };
        const MakeClockToNum = (clock) => {
          return +clock.split(" ")[1].split(":").join("");
        };
        if (aLastDate && bLastDate) {
          const aDateNum = MakeDateToNum(aLastDate);
          const bDateNum = MakeDateToNum(bLastDate);
          const aClockNum = MakeClockToNum(aLastDate);
          const bClockNum = MakeClockToNum(bLastDate);
          if (aDateNum === bDateNum) {
            return aClockNum - bClockNum;
          }
          return MakeDateToNum(aLastDate) - MakeDateToNum(bLastDate);
        }
        if (aLastDate && !bLastDate) {
          return 1;
        } else {
          return -1;
        }
      },
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => {
        const LastPlacementTest = LastPlacementTestSetter(record);
        const LastDate = LastPlacementTest?.active_due_date;
        const jalaliLastDate = LastPlacementTest?.jactive_due_date;
        let content = null;
        const timeHasCome = dayjs(LastDate).fromNow();
        let status = timeHasCome.includes("پیش") ? "error" : "processing";

        if (record.status === "TE") {
          status = "success";
        }
        const DateTextElement = (
          <div>
            <Tag color={status}>
              <div>{timeHasCome} </div>
              <div>
                <b>{jalaliLastDate}</b>
              </div>
            </Tag>
          </div>
        );
        switch (record.status) {
          case "TE":
            content = DateTextElement;
            break;
          case "TD":
            content = DateTextElement;
            break;
          case "NO":
            content = (
                <div onDoubleClick={(e)=>{
                  e.stopPropagation();
                  e.preventDefault();
                  e.nativeEvent.stopImmediatePropagation();
                }}>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  // value={LastDate ? new Date(LastDate) : null}
                  onOpenPickNewDate
                  onChange={(date , format) => {
                    if (date) {
                      let object = { date, format }
                      const newDate =  new DateObject(object).convert(gregorian, gregorian_en).format();
                      UpdateTestDate(record, new Date(newDate).toISOString());
                    }
                  }}
                  plugins={[
                    <TimePicker position="bottom" />
                  ]}
                  placeholder="تاریخ و ساعت را انتخاب کنید"
                  className={`${styles.customDatePicker} ${dateInputError === record ? styles.error : ''}`}
                  containerClassName={styles.calendarContainer}
                  inputClass={styles.customDatePickerInput}
                  format="YYYY/MM/DD HH:mm:ss"
                />
                </div>
            );
            break;
          default:
            content = null;
        }
        const last_placement_test_value = LastPlacementTestSetter(record);
        let dates = null;
        if (last_placement_test_value) {
          if (last_placement_test_value.jdue_dates) {
            dates = last_placement_test_value.jdue_dates.map((el, index) => {
              const IsLastElement =
                index === last_placement_test_value.jdue_dates.length - 1;
              return (
                <div>
                  <div
                    className={[
                      styles.DateItem,
                      IsLastElement ? styles.DateItemActive : null,
                    ].join(" ")}
                  >
                    <div className={styles.DateItemIcon}>
                      {IsLastElement ? <CheckOutlined /> : <CloseOutlined />}
                    </div>
                    {el}
                  </div>
                  {!IsLastElement ? <div className={styles.Line} /> : null}
                </div>
              );
            });
          } else {
            dates = <span>تاریخی وجود ندارد.</span>;
          }
        } else {
          dates = <span>تاریخی وجود ندارد.</span>;
        }
        return (
          <Space className={styles.DateCellContainer}>
            {content}
            <Popover content={dates} title="تاریخ‌ها">
              <Button type="link">بیشتر</Button>
            </Popover>
          </Space>
        );
      },
    },

    // {
    //   title: "نمره",
    //   key: "score",
    //   width: "11%",
    //   filters: ScoreFilter,
    //   onFilter: (value, record) => {
    //     switch (record.status) {
    //       case "NO":
    //         if (value === "NotTested") {
    //           return true;
    //         }
    //         break;
    //       case "TD":
    //         if (value === "NotSet") {
    //           return true;
    //         }
    //         break;
    //       case "TE":
    //         return last_placement_test(record).score === value;
    //       default:
    //         return false;
    //     }
    //   },

    //   filterSearch: true,
    //   render: (text, record, index) => {
    //     switch (record.status) {
    //       case "TE":
    //         return (
    //           <Tag color="success">{last_placement_test(record).score}</Tag>
    //         );
    //       case "TD":
    //         return (
    //           <AutoComplete
    //             status={scoreInputError === record ? "error" : ""}
    //             style={{ width: "100%" }}
    //             onChange={(value) => {
    //               UpdateScore(record, value);
    //             }}
    //             options={ScoreOptions}
    //             placeholder="سطح زبان را وارد کنید"
    //             filterOption={(inputValue, option) =>
    //               option.value
    //                 .toUpperCase()
    //                 .indexOf(inputValue.toUpperCase()) !== -1
    //             }
    //           />
    //         );
    //       case "NO":
    //         return <Tag color="warning">تعیین سطح نشده</Tag>;
    //       default:
    //         return null;
    //     }
    //   },
    // },
    {
      title: "کیفیت لید",
      dataIndex: "is_organic",
      key: "organic",
      width: "8%",
      filters: [
        { value: "ORGANIC", text: "ارگانیک" },
        { value: "NON-ORGANIC", text: "غیر ارگانیک" },
      ],
      onFilter: (value, record) => record.is_organic === value,
      render: (text, record, index) => {
        if (record.status === "NO") {
          return (
            <Select
              value={text}
              onChange={(value) => {
                UpdateOrganicField(value, record);
              }}
              style={{ width: "100%" }}
            >
              <Select.Option value="ORGANIC">ارگانیک</Select.Option>
              <Select.Option value="NON-ORGANIC">غیر ارگانیک</Select.Option>
            </Select>
          );
        } else {
          if (text === "ORGANIC") {
            return <Tag color="blue">ارگانیک</Tag>;
          }
          if (text === "NON-ORGANIC") {
            return <Tag color="red">ارگانیک</Tag>;
          }
        }
      },
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      width: "8%",
      filters: StatusFilter,
      onFilter: (value, record) => record.status.includes(value),
      filterSearch: true,
      render: (text, record, index) => {
        switch (record.status) {
          case "NO":
            return (
              <Tag color="processing" icon={<PauseCircleOutlined />}>
                {StatusSetter(record.status)}
              </Tag>
            );
          case "TE":
            return (
              <Tag color="success" icon={<CheckCircleOutlined />}>
                {StatusSetter(record.status)}
              </Tag>
            );
          case "TD":
            return (
              <Tag color="orange" icon={<FieldTimeOutlined />}>
                {StatusSetter(record.status)}
              </Tag>
            );
          default:
            return <Tag> {StatusSetter(record.status)}</Tag>;
        }
      },
    },
    {
      title: "عملیات",
      align: "center",
      children: [
        {
          title: "موفقیت",
          align: "center",
          width: "12%",
          render: (text, record, index) => {
            switch (record.status) {
              case "NO":
                return (
                  <Button
                    block
                    onClick={() => {
                      SetTestDate(record);
                    }}
                  >
                    ثبت تاریخ
                  </Button>
                );
              case "TE":
                return (
                  <Popconfirm
                    title="آیا از ثبت نام کردن کاربر مطمئن هستید؟"
                    onConfirm={() => {
                      SetRegister(record);
                    }}
                  >
                    <Button block type="default">
                      ثبت نام
                    </Button>
                  </Popconfirm>
                );
              case "TD":
                return (
                  <Button
                    block
                    type="default"
                    onClick={() => {
                      SendTestResult(record);
                    }}
                  >
                    ارسال نتیجه
                  </Button>
                );
              default:
                return null;
            }
          },
        },
        {
          title: "عدم موفقیت",
          align: "center",
          width: "8%",
          render: (text, record, index) => {
            switch (record.status) {
              case "NO":
                return (
                  <Popconfirm
                    okText="حذف"
                    okButtonProps={{ danger: true, type: "primary" }}
                    cancelButtonProps={{ type: "dashed" }}
                    title="آیا می‌خواهید این درخواست را حذف کنید؟"
                    placement="top"
                    onConfirm={() => {
                      DeleteRequest(record);
                    }}
                  >
                    <Button danger block type="dashed">
                      حذف درخواست
                    </Button>
                  </Popconfirm>
                );
              case "TE":
                return (
                  <Button
                    block
                    type="dashed"
                    onClick={() => {
                      AddToTrackingList(record);
                    }}
                  >
                    اضافه به لیست پیگیری
                  </Button>
                );
              case "TD":
                return (
                  <Button
                    block
                    type="dashed"
                    onClick={() => {
                      SetTestDateAgain(record);
                    }}
                  >
                    ثبت مجدد تاریخ
                  </Button>
                );
              default:
                return null;
            }
          },
        },
      ],
    },
  ];
  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="درخواست ثبت نام"
        extra={
          <Space>
            <Button
              icon={<PlusOutlined />}
              type="default"
              onClick={() => {
                navigate("/NewRequest");
              }}
            >
              درخواست جدید
            </Button>

            <Button
              icon={<ReloadOutlined />}
              type="default"
              disabled={loading}
              onClick={() => {
                fetchData();
              }}
            >
              بروزرسانی
            </Button>
            {/* <TableExportDropdown
              disabled={loading}
              name="درخواست ثبت نام"
              data={data}
              columns={columns}
            /> */}
            {/* <Statistic title="تعداد درخواست‌ها" value={112}  /> */}
          </Space>
        }
        avatar={{ icon: <InboxOutlined /> }}
        subTitle="| ثبت شده در سیستم"
      />
      <DataTable
        loading={loading}
        scroll={{ x: "calc(700px + 50%)" }}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading: state.loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) =>
      dispatch(actions.ErrorSetter(error, errorType)),
    ClearError: () => dispatch(actions.ClearError()),
    LoadingSetter: (error, errorType) => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Requests);
